/**
 * @version:               1.0.0
 * @createTime:            2021.10.09
 * @updateTime:            2021.10.09
 * @author:                zhangju
 * @description
 ***/

export default {
    name: 'zt-more',
    data() {
        return {
            crumbsList: [],
            // 栏目的编号
            lmid: '',
            // 栏目的名称
            lmmc: '',
            fbsj: '',
            fbdw: '',
            // 主题名称
            ztmc: '',
            // 主题编号
            ztid:'',
            data: {data:[]}
        };
    },
    mounted() {
        this.init();
        this.fbsj = this.$route.query.fbsj;
        this.fbdw = this.$route.query.fbdw;
    },
    methods: {
        init() {
            this.changeCrumb();
            this.getData();
        },
        changeCrumb() {
            this.lmid = this.$route.query.lmid;
            this.ztmc = this.$route.query.ztmc;
            this.lmmc = this.$route.query.lmmc;
            this.ztid = this.$route.query.ztid;
            this.crumbsList = [{
                name:'专题',
                key:'zt',
                path: '/zt'
            },
            {
                name: this.ztmc,
                key: '255',
                path: '/zt/detail',
                query: {
                    id: this.ztid,
                    title: this.ztmc
                }
            },
            {
                name: this.lmmc,
                key: '254'
            }];
        },
        // 获取栏目数据
        getData(queryInfo) {
            let params = {lmbh: this.lmid};
            if (queryInfo) {
                params = {
                    ...queryInfo,
                    ...params
                };
            }

            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.zt.more_hssp,
                params:params
            }).then((res) => {
                this.data = res.data;
                console.log(res.data);

            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/zt/xqhssp', query: {active:'zt', id:item.bh, fbsj: this.fbsj, fbdw: this.fbdw}});
            window.open(url.href, '_blank');
        }
    }
};
